import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { bind } from 'bind-event-listener';
import Blanket from '@atlaskit/blanket';
import { media } from '@atlaskit/primitives/compiled';
export var DesktopOnlyBackground = function DesktopOnlyBackground(_ref) {
  var Background = _ref.background,
    children = _ref.children;
  var isAboveSmallScreen = useMatchMedia(media.above.sm);
  return isAboveSmallScreen ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Background, null), /*#__PURE__*/React.createElement(Blanket, {
    isTinted: true
  }, children)) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export var useMatchMedia = function useMatchMedia(mediaQuery) {
  var query = mediaQuery.replace('@media', '').trim();
  var _React$useState = React.useState(function () {
      return window.matchMedia(query).matches;
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    matches = _React$useState2[0],
    setMatches = _React$useState2[1];
  React.useLayoutEffect(function () {
    var screen = window.matchMedia(query);
    var unbind = bind(screen, {
      type: 'change',
      listener: function listener(e) {
        setMatches(e.matches);
      }
    });
    return unbind;
  }, [query]);
  return matches;
};